import React, {useState} from 'react';
import Device from '@core/scripts/components/device';
import AppGallery from './actions/app-gallery';
import SourceImage from '../image/SourceImage.jsx';
import ProductImageZoom from './ProductImageZoom.jsx';

const FORBIDDEN_RADIUS = 5;

export default function ProductImage({
    image,
    images,
    zoomAllowed,
    lazy,
    slideIndex,
    dimensions,
    soldOut,
    texts,
    index,
    fullwidth
}) {
    const [zoomEnabled, setZoomEnabled] = useState(false);

    const onMouseMove = (event) => {
        if (Device.isMouse() && !zoomEnabled && isZoomWithCurrentMousePositionAllowed(event)) {
            setZoomEnabled(true);
        }
    };

    const onClick = () => {
        if (Device.isApp()) {
            const imageUrls = images?.filter(image => image.type !== 'VIDEO')
                .map((image) => image.detail.sources[0].srcSet.src2x);
            // PP-1172: Sometimes slideIndex is not yet updated when the user taps on the image too fast,
            // which causes an IndexOutOfBoundsException in the iOS app
            const index = (slideIndex + imageUrls.length) % imageUrls.length;
            AppGallery.open(imageUrls, index);
        }
    };

    // prevents image zoom on page load, when mouse is over image
    const isZoomWithCurrentMousePositionAllowed = (event) => {
        const pageLoadMousePosition = window.pageLoadMousePosition;
        if (!pageLoadMousePosition) {
            return false;
        }

        const xPositionAllowed =
            event?.clientX >= pageLoadMousePosition.x + FORBIDDEN_RADIUS ||
            event?.clientX <= pageLoadMousePosition.x - FORBIDDEN_RADIUS;
        const yPositionAllowed =
            event?.clientY >= pageLoadMousePosition.y + FORBIDDEN_RADIUS ||
            event?.clientY <= pageLoadMousePosition.y - FORBIDDEN_RADIUS;

        return xPositionAllowed || yPositionAllowed;
    };

    const currentImage = image.preview;

    if (!zoomAllowed) {
        return (
            <div className={'product-image__wrapper -no-pointer-events' + (image.needsExtraSpacing && !fullwidth ? ' -with-extra-spacing' : '')}>
                <SourceImage
                    image={currentImage}
                    className={'product-image__image' + (soldOut ? ' is-inactive' : '')}
                    lazy={lazy}
                    dimensions={dimensions}
                />
                {soldOut && <div className="product-image__sold-out-text">{texts.ada_ausverkauft}</div>}
            </div>
        );
    }

    return (
        <>
            <div
                onClick={onClick}
                onMouseMove={onMouseMove}
                className={'product-image__wrapper' + (image.needsExtraSpacing && !fullwidth ? ' -with-extra-spacing' : '')}
            >
                <SourceImage
                    image={currentImage}
                    className={'product-image__image' + (soldOut ? ' is-inactive' : '')}
                    lazy={lazy}
                    dimensions={dimensions}
                />
            </div>
            {zoomEnabled && (
                <ProductImageZoom
                    image={image}
                    zoomEnabled={zoomEnabled}
                    onZoomImageLeave={() => setZoomEnabled(false)}
                />
            )}
        </>
    );
}
